import { NavLink } from "react-router-dom";

function ButtonsContact(props: any) {
  const { data } = props;

  return (
    <section className="buttons-contact-container container">
      {data.map(
        (item: { icon: string; text: string; link: string, name: string }, i: any) => (
          <div className="buttons-contact-content" key={i}>
            <NavLink to={item.link} target="_blank" >
              <button className="button-contact">
                {item.icon}
                <p>{item.text}</p>
                <p className="hidden-button-name">{item.name}</p>
              </button>
            </NavLink>
          </div>
        )
      )}
    </section>
  );
}

export default ButtonsContact;
